import FeaturedOffersModule from './FeaturedOffersModule';

export default FeaturedOffersModule;
